import * as React from "react";
import { forwardRef } from "react";
const FlywireIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 48 48",
  "data-category": "payment-methods",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#flywire-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1274C4",
  d: "m23.0509 21.7556.3149-1.8661H11.8335l.4741-2.9673h11.5251l.224-1.4182c.6597-4.1316 3.4306-6.50981 7.6328-6.50399h2.309l-.453 2.89239-2.1637-.0044c-2.3374-.0022-3.6727 1.1542-4.0945 3.7346l-.2066 1.2996h4.4568l-.4728 2.9673h-4.4509l-2.4291 14.3723c-.6618 4.1288-3.4749 6.4924-7.7018 6.4873l-.2422-.0015.4931-3.133.1578-.0015c2.3782.0029 3.6582-1.0036 4.0786-3.5709l1.5782-9.3215H11l.4742-2.9658h11.5767z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "flywire-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h48v48H0z"
}))));
const ForwardRef = forwardRef(FlywireIcon);
ForwardRef.category = "payment-methods";
export { ForwardRef as FlywireIcon };